// Sects (门派) module
const knownSects = ['无名门派','青云宗','太玄门','玄天宗','玲珑派'];

const sectData = {
  '青云宗': {
    bonuses: ['攻击 +10%', '剑术技能传承'],
    description: '以剑术闻名，专注攻击力提升'
  },
  '太玄门': {
    bonuses: ['炼丹成功率 +15%', '丹药品质提升'],
    description: '精通炼丹之术，炼丹成功率提升'
  },
  '玄天宗': {
    bonuses: ['防御 +10%', '护体技能传承'],
    description: '防御坚固，擅长护体神功'
  },
  '玲珑派': {
    bonuses: ['探索速度 +20%', '身法技能传承'],
    description: '身法灵动，移动速度提升'
  }
};

function joinSect(state, name) {
  if (!name) {
    // 检查是否有模态框支持，如果有则打开模态框，否则显示列表
    if (state.inSectModal !== undefined) {
      // 打开宗门模态框
      state.inSectModal = true;
      return [{ type: 'open_sect_modal' }];
    } else {
      // 向后兼容：显示可选宗门列表，每个宗门后跟可点击的宗门命令
      const sects = knownSects.map(sect => `${sect} - 宗门 ${sect}`);
      return ['可选门派：'].concat(sects);
    }
  }
  if (!knownSects.includes(name)) return [`未找到门派 ${name}。`];

  // 如果已经加入了这个宗门
  if (state.sect === name) return [`你已经是 ${name} 的弟子了。`];

  // 加入宗门
  state.sect = name;

  // 根据宗门给予奖励（向后兼容：如果没有新的逻辑，保持原有行为）
  const bonuses = sectData[name]?.bonuses || [];
  let bonusText = '';
  if (bonuses.length > 0) {
    bonusText = ` 宗门特效：${bonuses.join('，')}`;
  }

  return [`你加入了 ${name}。${bonusText}`];
}

function listSects() {
  return knownSects.slice();
}

function getSectBonuses(state) {
  if (!state.sect || state.sect === '无名门派') return {};
  return sectData[state.sect] || {};
}

function getSectInfo(name) {
  if (!sectData[name]) return null;
  return {
    name,
    ...sectData[name]
  };
}

function getAllSects() {
  return Object.keys(sectData).map(name => ({
    name,
    ...sectData[name]
  }));
}

export { joinSect, listSects, getSectBonuses, getSectInfo, getAllSects };
